export type EarlyContactAuthHandle = {
  token: string
  response: Promise<Response>
}

declare global {
  interface Window {
    __SIGCHAT_EARLY_CONTACT_AUTH__?: EarlyContactAuthHandle
    __SIGCHAT_EARLY_UNIFIED_MANIFEST__?: Promise<unknown>
  }
}

export function takeEarlyContactAuthResponse(token: string): Promise<Response> | undefined {
  const handle = window.__SIGCHAT_EARLY_CONTACT_AUTH__
  const trimmed = token.trim()
  if (!handle || handle.token !== trimmed) return undefined
  delete window.__SIGCHAT_EARLY_CONTACT_AUTH__
  return handle.response
}

export function takeEarlyUnifiedManifest(): Promise<unknown> | undefined {
  const pending = window.__SIGCHAT_EARLY_UNIFIED_MANIFEST__
  if (!pending) return undefined
  delete window.__SIGCHAT_EARLY_UNIFIED_MANIFEST__
  return pending
}
